// Appbar.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Typography,
  Button,
  Box,
  IconButton,
} from '@mui/material';
import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded';
import CloseIcon from '@mui/icons-material/Close';
import { useAccount } from '../context/AccountContext';
import * as AppUrls from '../common/AppUrls';


const SubscriptionBanner = () => {
  const { account } = useAccount();
  const navigate = useNavigate();
  const [dismissed, setDismissed] = useState(false);

  const trialEndStr = account?.organization?.trial_end_date;  // "2026-06-12"
  if (!trialEndStr || dismissed) return null;

  let daysLeft = Math.ceil(
    (new Date(`${trialEndStr}T00:00:00`) - new Date().setHours(0, 0, 0, 0))
    / (1000 * 60 * 60 * 24)
  );
  daysLeft = daysLeft + 1;  // Convert 0 indexed to 1 indexed
  if (daysLeft > 5) return null;  // 7

  const expired = daysLeft <= 0;
  const critical = daysLeft <= 2; // 3
  const daysLeftStr = `${daysLeft} day${daysLeft !== 1 ? 's' : ''}`;

  const banner = expired ? {
    severity: 'error',
    message: 'Your free trial has ended. Subscribe to restore full access.',
    colors: {
      bg: '#fff5f5',
      border: '#fecaca',
      text: '#b91c1c',
    },
  } : critical ? {
    severity: 'warning',
    message: `Your free trial ends in ${daysLeftStr}. Subscribe now to avoid any interruption.`,
    colors: {
      bg: '#fffbeb',
      border: '#fde68a',
      text: '#b45309',
    },
  } : {
    severity: 'info',
    message: `You're currently on a free trial. ${daysLeftStr} remaining.`,
    colors: {
      bg: '#eff6ff',
      border: '#bfdbfe',
      text: '#1d4ed8',
    },
  };

  return (
    <Box
      sx={{
        // mx: 0.5,
        px: 2, py: 1,
        borderRadius: 2, border: `1px solid ${banner.colors.border}`,
        backgroundColor: banner.colors.bg,
        display: 'flex', alignItems: 'center',
        gap: 1,
      }}
    >
      <WarningAmberRoundedIcon
        sx={{
          color: banner.colors.text,
          fontSize: 22,
          flexShrink: 0,
        }}
      />

      <Box sx={{ flexGrow: 1, minWidth: 0 }}>
        <Typography
          variant="caption"
          sx={{
            color: banner.colors.text,
            fontWeight: 500,
          }}
        >
          {banner.message}
        </Typography>
      </Box>

      <Button
        size="small"
        variant="contained"
        onClick={() => navigate(AppUrls.MANAGE_SUBSCRIPTION_URL)}
        // sx={{
        //   whiteSpace: 'nowrap', borderColor: colors.border, color: colors.text,
        //   '&:hover': { borderColor: colors.text }
        // }}
      >
        Subscribe
      </Button>

      <IconButton
        size="small"
        onClick={() => setDismissed(true)}
        sx={{ color: banner.colors.text }}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </Box>
  );
};

export default SubscriptionBanner;
